import { EquallyDistributed } from './EquallyDistributed';
import { Tiered as TieredComponent } from './Tiered';

const Tiered = Object.assign(TieredComponent, { EquallyDistributed });
export { EquallyDistributed, Tiered };
